module.exports = __webpack_public_path__ + "img/appbg.9a09b488.png";